export enum MessageType {
  Advertisement = 'Advertisement',
  Alert = 'Alert',
  Information = 'Information',
  Reminder = 'Reminder',
  Standard = 'Standard',
  Warning = 'Warning',
  Notification = 'Notification'
}
